import { render } from "./EditAjustesOrigen.vue?vue&type=template&id=cfaecf7e&scoped=true"
import script from "./EditAjustesOrigen.vue?vue&type=script&lang=js"
export * from "./EditAjustesOrigen.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./EditAjustesOrigen.vue?vue&type=style&index=1&id=cfaecf7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfaecf7e"]])

export default __exports__